// src/components/Services/Services.js
import React from 'react';
import { Helmet } from 'react-helmet-async';

import './Services.css';
import WebDevelopmentServices from './WebDevelopmentServices/WebDevelopmentServices';
import EmailDevelopmentServices from './EmailDevelopmentServices/EmailDevelopmentServices';

const Services = () => {
  return (
    <>
      <Helmet>
        <title>Services by Srihari Muppalla | Full Stack Developer & Web Developer & Email Developer in Bangalore </title>
        <meta
          name="description"
          content="Explore services by Srihari Muppalla, a Full Stack Developer in Bangalore, India. Offering web development, email development, and full-stack solutions for businesses."
        />
        <meta
          name="keywords"
          content="Srihari Muppalla, Full Stack Developer, services, Bangalore, India, web development, email development, React.js, Node.js, Express.js, Next.js, HTML, CSS, JavaScript and AMP Script"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Srihari Muppalla" />
        <link rel="canonical" href="https://sriharim.in/services" />

        {/* Open Graph Tags */}
        <meta
          property="og:title"
          content="Services by Srihari Muppalla | Full Stack Developer & Web Developer & Email Developer in Bangalore"
        />
        <meta
          property="og:description"
          content="Explore services by Srihari Muppalla, a Full Stack Developer in Bangalore, India. Offering web development, email development, and full-stack solutions for businesses."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://sriharim.in/services" />
        <meta property="og:image" content="https://sriharim.in/Logo.png" /> {/* Replace with a relevant image */}
        <meta property="og:image:alt" content="Services by Srihari Muppalla" />
        <meta property="og:site_name" content="Srihari Muppalla Portfolio" />

        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Services by Srihari Muppalla | Full Stack Developer & Web Developer & Email Developer in Bangalore"
        />
        <meta
          name="twitter:description"
          content="Explore services by Srihari Muppalla, a Full Stack Developer in Bangalore, India. Offering web development, email development, and full-stack solutions for businesses."
        />
        <meta name="twitter:image" content="https://sriharim.in/Logo.png" /> {/* Replace with a relevant image */}
        <meta name="twitter:image:alt" content="Services by Srihari Muppalla" />
        <meta name="twitter:creator" content="@srihariM64" /> {/* Replace with your Twitter handle */}
      </Helmet>
      <div className="services-container">
        <h1 className="services-title">Services</h1>
        <p className="services-subtitle">
          Discover my professional services in web development and email development, designed to elevate your online presence and engage your audience effectively.
        </p>
        <div className="services-grid">
          <WebDevelopmentServices />
          <EmailDevelopmentServices />
        </div>
      </div>
    </>
  );
};

export default Services;